<template>
  <div>
    <a-modal v-model:open="open" title="Enter Track Code">
      <div class="search-row">
        <div class="track-input">
          <a-input
            v-model:value="trackCode"
            placeholder="Track Code"
            @change="validateCode"
            @pressEnter="handleOk" />
          <div
            v-if="helpMessage"
            :style="{
              color: isValid ? 'green' : 'red',
              marginTop: '8px',
              opacity: 0.6,
            }">
            {{ helpMessage }}
          </div>
        </div>
        <a-button
          key="submit"
          type="primary"
          @click="handleOk"
          :disabled="!isValid">
          Ok
        </a-button>
      </div>
      <template #footer> </template>
    </a-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      open: false,
      trackCode: '',
      isValid: false,
      helpMessage: '',
    };
  },
  methods: {
    showModal() {
      this.open = true;
    },
    validateCode() {
      this.isValid = false;

      if (!this.trackCode) {
        this.helpMessage = '';
        return;
      }

      const code = this.trackCode.trim();

      if (!/^pp/i.test(code)) {
        this.helpMessage = 'Track number must start with PP';
        return;
      }

      if (code.length < 15) {
        this.helpMessage = 'Track number must be 15 characters long';
        return;
      }

      if (code.length > 15) {
        this.helpMessage = 'Track number is too long';
        return;
      }

      // Если все проверки пройдены
      this.isValid = true;
      this.helpMessage = 'Press enter or search';
    },
    handleOk() {
      if (!this.isValid) {
        return;
      }

      const cleanCode = this.trackCode.trim().toUpperCase();
      this.$router.push(`/MyParcels/${cleanCode}`);
      this.open = false;
    },
  },
};
</script>

<style scoped>
.search-row {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 8px;
}

.track-input {
  width: 100%;
}
</style>
